export default {
  name: 'admin',
  component: () =>
    import(
      /* webpackChunkName: "Auth Layout" */ '@/modules/admin/layouts/AuthLayout.vue'
    ),
  children: [
    {
      path: 'subida-archivos',
      name: 'homeAdmin',
      meta: { title: "Subida de archivos" },
      component: () =>
        import(
          /* webpackChunkName: "Login View" */ '@/modules/admin/views/home/HomeAdminView.vue'
        ),
    },
    {
      path: 'letras-digitales',
      name: 'digitalLetters',
      meta: { title: "Letras digitales" },

      component: () =>
        import(
          /* webpackChunkName: "Login View" */ '@/modules/admin/views/letters/LettersAdminView.vue'
        ),
    },
    {
      path: 'facturas-contado',
      name: 'cashBillingAdmin',
      meta: { title: "Facturas contado" },
      component: () =>
        import(
          /* webpackChunkName: "Cash Billing View" */ '@/modules/shared/cashBilling/views/CashBillingView.vue'
        ),
    },
    {
      path: 'contactos-contado',
      name: 'cashContactsAdmin',
      meta: { title: "Contactos de contado" },
      component: () =>
        import(
          /* webpackChunkName: "Cash Contacts View" */ '@/modules/shared/cashBilling/views/CashContactsView.vue'
        ),
    },
    {
      path: 'vendedores',
      name: 'salesUsers',
      meta: { title: "Vendedores" },
      component: () =>
        import(
          /* webpackChunkName: "Sales Users View" */ '@/modules/admin/views/sellers/SalesUsersView.vue'
        ),
    },
    {
      path: 'clients',
      name: 'clients',
      meta: { title: "Clientes" },

      component: () =>
        import(
          /* webpackChunkName: "Login View" */ '@/modules/admin/views/clients/index.vue'
        ),
    },

    {
      path: ':pathMatch(.*)*',
      redirect: {
        name: 'homeAdmin',
      },
    },
  ],
};
